import React, { useState } from "react";
import { Link, graphql } from "gatsby";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import Seo from "gatsby-plugin-wpgraphql-seo";
//import { FaYoutube } from "react-icons/fa6";

import { Layout, Banner } from "../components";
//import YoutubePlay from "../../static/yt-icon.png";
import TestiQuote from "../../static/testi.png";

const IndexPage = ({
  data: {
    wpPage,
    wpPage: { pageMeta, homePageMeta },
    //allWpPost: { nodes },
  },
}) => {
  const legacyOfExcellenceCounters = homePageMeta.legacyOfExcellenceCounters;
  //const youtubeSlider = homePageMeta.youtubeSlider;
  const bannerCounters = homePageMeta.bannerCounters;
  const servicesTabs = homePageMeta.servicesTabs;
  const eyeCareContent = homePageMeta.eyeCareContent;
  const eyeCareImage =
    homePageMeta.eyeCareImage.localFile.childImageSharp.gatsbyImageData;
  const eyeCareUrl = homePageMeta.eyeCareUrl;
  const doctorImage =
    homePageMeta.doctorProfileImage.localFile.childImageSharp.gatsbyImageData;
  const testimonials = homePageMeta.testimonialsList;
  const [selectedService, setSelectedService] = useState(
    "Precision Diabetes Services"
  );
  return (
    <>
      <Seo post={wpPage} />
      <Layout>
        {/* Banner Section */}
        <Banner banner={pageMeta.pageBanner} />
        <section className="bg-white">
          <div className="flex flex-row flex-wrap">
            {bannerCounters.length > 0 &&
              bannerCounters.map((counter, index) => {
                return (
                  <div
                    className={` w-1/2 basis-1/2 px-4 text-center lg:mb-0 lg:w-1/4 lg:basis-1/4 ${
                      index % 2 === 0 ? "bg-primary" : "bg-secondary"
                    }`}
                    key={index}
                  >
                    <h3
                      className={`lh-48 font-openSans text-xl text-white 2xl:text-4xl`}
                    >
                      {counter.counter} {counter.title}
                    </h3>
                  </div>
                );
              })}
          </div>
        </section>
        <section className="bg-white py-12">
          <div className="container mx-auto">
            <div className="px-4 pb-12">
              <h2 className=" mb-4 text-center font-openSans text-2xl text-secondary 2xl:text-4xl">
                Complete Diabetes Treatment under One Roof
              </h2>
              <p className=" mb-0 text-center font-openSans text-xl text-black 2xl:text-2xl">
                We offer personalized, evidence-based care for individuals with
                diabetes, prioritizing their well-being.
              </p>
            </div>
            <div className="my-4 flex flex-row flex-wrap">
              <div className=" w-full basis-full rounded-md px-4 lg:w-1/2 lg:basis-1/2">
                {servicesTabs.map((service, index) => (
                  <button
                    key={index}
                    className={`rounded-inherit block w-full px-6 py-2 text-left font-openSans text-lg transition-all duration-500 hover:bg-white hover:text-primary lg:px-16 lg:py-4 2xl:text-4xl ${
                      selectedService === service.title
                        ? "bg-white text-primary"
                        : "bg-primary text-white"
                    }`}
                    onClick={(e) =>
                      setSelectedService((prevState) => service.title)
                    }
                  >
                    {service.title}
                  </button>
                ))}
              </div>
              <div className=" mt-4 w-full basis-full px-4 text-center lg:mt-0 lg:w-1/2 lg:basis-1/2">
                {servicesTabs.map((service, index) => {
                  const image = getImage(
                    service.image?.localFile?.childImageSharp?.gatsbyImageData
                  );
                  return (
                    <div
                      key={index}
                      className={`${
                        selectedService === service.title ? "block" : "hidden"
                      }`}
                    >
                      <GatsbyImage image={image} alt="" />
                      <div
                        className="mt-4 mb-4 font-openSans text-lg text-black 2xl:text-2xl"
                        dangerouslySetInnerHTML={{ __html: service.content }}
                      ></div>
                      {service.link && service.link.uri && (
                        <Link
                          to={service.link.uri}
                          className="inline-block rounded-md bg-primary py-4 px-12 font-openSans text-white"
                        >
                          Know More
                        </Link>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </section>
        <section className="bg-white py-12">
          <div className="container mx-auto">
            <GatsbyImage image={eyeCareImage} className="mb-8 w-full" alt="" />
            <div className="flex flex-row flex-wrap">
              <div className=" w-full basis-full px-4 lg:w-1/3 lg:basis-1/3">
                <h2 className="mb-8 font-openSans text-2xl font-bold text-secondary 2xl:text-4xl">
                  Eye Care at Dr. Mohan’s
                </h2>
                {eyeCareUrl && (
                  <Link
                    to={eyeCareUrl}
                    className="inline-block rounded-md bg-primary py-4 px-12 font-openSans text-white"
                  >
                    Know More
                  </Link>
                )}
              </div>
              <div className=" w-full basis-full px-4 lg:w-2/3 lg:basis-2/3">
                <p
                  className="mb-0 mt-8 font-openSans text-lg text-black lg:mt-0 2xl:text-2xl"
                  dangerouslySetInnerHTML={{ __html: eyeCareContent }}
                ></p>
              </div>
            </div>
          </div>
        </section>
        <section className="bg-white py-12">
          <div className="container mx-auto">
            {/* Doctor Profile Desktop */}
            <div className="mx-auto hidden w-3/4 items-center lg:flex lg:flex-row">
              <div className=" flex-1 px-4">
                <GatsbyImage image={doctorImage} alt="" />
              </div>
              <div className=" flex-1 px-4 text-left">
                <h2 className="mb-2 font-openSans text-xl text-secondary 2xl:text-4xl">
                  {homePageMeta.doctorProfileName}
                </h2>
                <h4 className="mb-8 font-openSans text-lg text-black 2xl:text-xl">
                  {homePageMeta.doctorProfileTitle}
                </h4>
                <div
                  className="mb-8 font-openSans text-base text-black 2xl:text-2xl"
                  dangerouslySetInnerHTML={{
                    __html: homePageMeta.doctorProfileContent,
                  }}
                ></div>
                {homePageMeta.doctorProfileUrl && (
                  <Link
                    to={homePageMeta.doctorProfileUrl}
                    className="inline-block rounded-md bg-primary py-4 px-12 font-openSans text-white"
                  >
                    Read More
                  </Link>
                )}
              </div>
            </div>
            {/* Doctor Profile Mobile */}
            <div className="mx-auto flex flex-col items-center lg:hidden">
              <div className="mb-8 flex-1 px-4 text-center">
                <h2 className=" mb-4 text-left font-openSans text-xl text-secondary">
                  {homePageMeta.doctorProfileName}
                </h2>
                <h4 className=" font-openSans text-lg text-black">
                  {homePageMeta.doctorProfileTitle}
                </h4>
              </div>
              <div className=" mb-8 flex-1 px-4">
                <GatsbyImage image={doctorImage} alt="" />
              </div>
              <div className=" flex-1 px-4 text-left">
                <div
                  className="mb-8 font-openSans text-base text-black"
                  dangerouslySetInnerHTML={{
                    __html: homePageMeta.doctorProfileContent,
                  }}
                ></div>
                {homePageMeta.doctorProfileUrl && (
                  <Link
                    to={homePageMeta.doctorProfileUrl}
                    className="inline-block rounded-md bg-primary py-4 px-8 font-openSans text-white"
                  >
                    Read More
                  </Link>
                )}
              </div>
            </div>
          </div>
        </section>
        <section className="bg-white py-6">
          <div className="container mx-auto pt-4">
            <div className="flex flex-row flex-wrap">
              {legacyOfExcellenceCounters.map((counter, index) => {
                return (
                  <div
                    className={` mb-8 w-full basis-full px-4 text-center transition-all duration-500 lg:mb-0 lg:w-1/5 lg:basis-1/5`}
                    key={index}
                  >
                    <div
                      className={`h-full rounded-md p-4 ${
                        index % 2 === 0 ? "bg-primary" : "bg-secondary"
                      }`}
                    >
                      <h3 className="mb-0 font-openSans text-xl text-white 2xl:text-4xl">
                        {counter.counter}
                        {counter.counterSymbol}
                      </h3>
                      <p className="mb-0 font-openSans text-lg text-white 2xl:text-xl">
                        {counter.title}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
        <section className="bg-white py-12">
          <h2 className=" mb-12 text-center font-openSans text-xl font-bold text-secondary 2xl:text-4xl">
            What Our Patients And Peers Think about Us
          </h2>
          {/* Testimonials */}
          <div className=" mx-4 lg:mx-0">
            <Swiper
              slidesPerView={1}
              spaceBetween={15}
              centeredSlides={true}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                1024: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
              }}
              loop={true}
              className="testimonialSwiper"
              navigation={true}
              modules={[Navigation, Autoplay]}
            >
              {testimonials.map((item, index) => {
                const image = item.image
                  ? getImage(
                      item.image.localFile.childImageSharp.gatsbyImageData
                    )
                  : null;
                return (
                  <SwiperSlide key={index}>
                    <div className="custom-color h-full rounded-2xl p-8 text-center text-white">
                      <img
                        src={TestiQuote}
                        className="mb-8 inline-block"
                        alt=""
                      />
                      <div
                        className="font-openSans text-lg text-black 2xl:text-xl"
                        dangerouslySetInnerHTML={{ __html: item.content }}
                      ></div>
                      <div className="mt-6">
                        <GatsbyImage image={image} alt="" />
                        <div className="px-4">
                          <h3 className="font-openSans text-lg text-primary 2xl:text-xl">
                            {item.name}
                          </h3>
                          <h4 className="font-openSans text-lg text-black 2xl:text-xl">
                            {item.title}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </section>
        {/* <section className="bg-white py-24">
          <div className="container mx-auto">
            <div className="flex flex-row flex-wrap">
              <div className="w-full basis-full px-4 lg:w-1/2 lg:basis-1/2">
                <h2 className=" mb-4 font-openSans text-4xl capitalize text-secondary">
                  watch our videos
                </h2>
                <p className="mb-8 font-openSans text-black">
                  At Dr. Mohan's Diabetes Specialties Centre, we pride ourselves
                  on our ability to effectively treat a wide range of diabetes
                  cases, including different types such as LADA, Type 1, Type 2,
                  Gestational Diabetes. Our team of experienced healthcare
                  professionals understands the unique needs and challenges that
                  come with each type of diabetes diagnosis. For those with
                  Latent Autoimmune Diabetes in Adults (LADA), we offer
                  specialized care tailored to managing this form of the disease
                  that shares characteristics of both type 1 and type 2
                  diabetes.
                </p>
                <a
                  href="https://www.youtube.com/channel/UC6BJrjTVCIMniKYU175QClw"
                  className="inline-block rounded-md bg-primary py-4 px-8 font-openSans text-white"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaYoutube className="inline-block" /> Our Youtube Channel
                </a>
                <a
                  href="https://www.youtube.com/channel/UC6BJrjTVCIMniKYU175QClw"
                  className="mt-4 ml-0 inline-block rounded-md border border-solid border-primary bg-white py-4 px-8 font-openSans text-primary lg:ml-4 lg:mt-0"
                  target="_blank"
                  rel="noreferrer"
                >
                  See More
                </a>
              </div>
              <div className="mt-8 w-full basis-full px-4 lg:mt-0 lg:w-1/2 lg:basis-1/2">
                <Swiper
                  slidesPerView={1}
                  spaceBetween={15}
                  centeredSlides={true}
                  pagination={{
                    clickable: true,
                  }}
                  breakpoints={{
                    1024: {
                      slidesPerView: 2,
                      spaceBetween: 30,
                    },
                  }}
                  navigation={true}
                  modules={[Navigation]}
                >
                  {youtubeSlider.map((item, index) => {
                    const image = getImage(
                      item.localFile.childImageSharp.gatsbyImageData
                    );
                    return (
                      <SwiperSlide key={index}>
                        <a href={item.title} target="_blank" rel="noreferrer">
                          <GatsbyImage
                            image={image}
                            className="w-full"
                            alt=""
                          />
                          <span className="absolute left-1/2 bottom-4 inline-block w-3/4 -translate-x-1/2 rounded-xl bg-white px-8 py-4 text-center font-openSans text-lg text-primary">
                            <img
                              src={YoutubePlay}
                              alt=""
                              className="inline-block"
                            />{" "}
                            Read more
                          </span>
                        </a>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </div>
            </div>
          </div>
        </section> */}
      </Layout>
    </>
  );
};

export default IndexPage;

export const query = graphql`
  query HomepageQuery($id: Int) {
    wpPage(databaseId: { eq: $id }) {
      pageMeta {
        pageBanner {
          desktopImage {
            localFile {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
              }
            }
          }
          mobileImage {
            localFile {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
              }
            }
          }
          captionTitle
          captionContent
          buttonLink
          buttonLabel
          showWhiteLogo
          whiteColor
          position
        }
      }
      homePageMeta {
        legacyOfExcellenceCounters {
          counter
          counterSymbol
          title
        }
        bannerCounters {
          counter
          counterSymbol
          title
        }
        servicesTabs {
          title
          content
          image {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          link {
            ... on WpService {
              uri
            }
            ... on WpPage {
              uri
            }
          }
        }
        eyeCareContent
        eyeCareImage {
          localFile {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
        eyeCareUrl
        doctorProfileContent
        doctorProfileName
        doctorProfileTitle
        doctorProfileUrl
        doctorProfile {
          localFile {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
        doctorProfileImage {
          localFile {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
        testimonialsList {
          name
          title
          content
          image {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
        youtubeSlider {
          title
          localFile {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
      seo {
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        canonical
        cornerstone
        schema {
          articleType
          pageType
          raw
        }
      }
    }
    allWpPost(limit: 4) {
      nodes {
        title
        uri
        date(formatString: "")
        featuredImage {
          node {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
      }
    }
  }
`;
